module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/glyphicons/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/glyphicons/fonts/glyphicons-halflings-regular.woff
// module chunks = styles